// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleGaugeOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import HighchartOptionsBuilder from 'share/components/charting/highcharts/Izenda.HighchartOptionsBuilder';
import HighchartUtils from 'share/components/charting/highcharts/Izenda.HighchartUtils';
import { get, find, isNil, head } from 'lodash/fp';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('SimpleGaugeOptionsBuilder')
export default class SimpleGaugeOptionsBuilder extends HighchartOptionsBuilder {
  constructor(...baseArgs) {
    super(...baseArgs);
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */
  buildOptionsByType(visualType: string, userOptions, dataParser): Object {
    const izendaOptions = userOptions.izendaOptions;
    const izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
    const firstPoint = get('series[0].data[0]', userOptions);
    const customFormat = HighchartUtils.getCustomFormat(userOptions);
    const configData = izendaSeriesConfig[izendaOptions.serieName];
    const element = find(
      f => f.fieldNameAlias === get('fieldElement.field.fieldNameAlias', configData),
      dataParser.fieldsMapping
    );

    if (firstPoint) {
      Object.assign(firstPoint, {
        serieName: izendaOptions.serieName,
        unit: izendaOptions.dataUnit,
        dataFormatter: (value: any, record: any) => {
          const fieldValue = {
            value: customFormat || value,
            originalValue: value
          }
          return dataParser.getFormatData(fieldValue, configData, { element: element, record: record })
        }
      });
    }

    return {
      chart: {
        events: {
          click: HighchartUtils.onDrilldownGauge(userOptions, head(userOptions.series))
        }
      },
      title: {
        text: ''
      },
      series: [{ data: [firstPoint] }]
    };
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.SimpleGaugeOptionsBuilder.js